import React from "react";
import { Loading } from "react-admin";

const PermissionLoading: React.FC = () => {
  return (
    <Loading
      loadingPrimary="Please wait..."
      loadingSecondary="Your request will show up here"
    />
  );
};

export default React.memo(PermissionLoading);
